/* global I18N */

import { Controller } from 'stimulus';

class PasswordController extends Controller {
  onBlur({ currentTarget }) {
    const password = currentTarget.value;

    const validationStatus = PasswordController.validate(password);

    if (validationStatus !== true) {
      this.outputMessage(validationStatus);
      return;
    }

    this.hideMessage();
  }

  outputMessage(message) {
    this.errorsTarget.removeAttribute('hidden');
    this.errorsTarget.textContent = I18N.errors[message];
  }

  hideMessage() {
    this.errorsTarget.setAttribute('hidden', 'hidden');
  }

  static validate(password) {
    if (password.length < 6) {
      return 'length';
    }

    // Password should contain capitals
    if (!/[A-Z]/.test(password)) {
      return 'capitals';
    }

    // Password should contain special characters (non-letters)
    if (!/[^A-z]/.test(password)) {
      return 'specialCharacters';
    }

    return true;
  }
}

PasswordController.targets = [
  'errors',
];

export default PasswordController;
